// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"bc6b71fa","977":"99da6588"}[chunkId] + ".chunk.js";
};